<template>
  <div role="presentation">
    <div
      v-if="isLoadingReport"
      class="py-10 px-4"
    >
      <span
        class="flex flex-col mt-1"
      >
        <aha-skeleton-loader
          class="mb-1"
          width="90%"
          height="12px"
        />
        <aha-skeleton-loader
          class="mb-1"
          width="70%"
          height="12px"
        />
        <aha-skeleton-loader
          width="30%"
          height="12px"
        />
      </span>
    </div>
    <div
      v-if="feedbackListLength && !isLoadingReport"
      class="report-private-feedback "
    >
      <div v-if="totalRatings" class="box-ratting">
        <div class="rating  bg-secondary-15">
          <div class="text-base-90 font-bold rating-avg">
            {{ avgRating }}
          </div>
          <div class="rating-content text-center">
            <AhaStarRatingView
              class="flex justify-center"
              :rate="Number(avgRating)"
              size="16px"
            />
            <div class="text-left text-xs text-base-80 mt-1">
              {{ totalRatings > 1
                ? $i18nPresenter.t('x ratings', { number: totalRatings })
                : $i18nPresenter.t('x rating', { number: totalRatings })
              }}
            </div>
          </div>
        </div> <!-- /.rating -->
      </div>
      <div v-if="feedbackListLength" class="box-feedback">
        <div
          v-for="(item) in feedbackList"
          :key="item.id"
          class="mb-3"
        >
          <FeedbackItemV2
            :feedbackGroup="item"
          />
        </div>
      </div>
    </div>
    <div
      v-if="!feedbackListLength && !isLoadingReport"
      class="text-center py-6 px-4"
    >
      <div class="inline-block mb-6">
        <img
          src="@/assets/images/report/feedback.svg"
          width="172"
          height="100"
          alt=""
        >
      </div>

      <div class="text-sm">
        {{ $i18nPresenter.t("Feedback from your participants will be shown here.") }}
      </div>
    </div>
  </div>
</template>

<script>
import FeedbackItemV2 from './FeedbackItemV2.vue'
import ReportMixin from '@/components-v2/presentation-report/ReportMixin'

export default {
  components: {
    FeedbackItemV2,
  },
  mixins: [ReportMixin],
  props: {
    oldFeedbacks: {
      type: Array,
      default: null,
    },
    newFeedbacks: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.report-private-feedback {
  margin-top: 20px;
  padding: 0px 24px 16px 24px;
  display: flex;
  gap:12px;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
}

.box-ratting {
  padding-top: 12px;
  border-radius: 4px;
  display: flex;
  align-items: baseline;
}

.rating {
  @apply rounded-md;
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px;

  &-content {
    position: relative;
    max-width: 250px;
    margin-left: auto;
    margin-right: auto;
  }

  &-avg {
    font-size: 40px;
    line-height: 54px;
    margin-right: 8px;
    color: #313131;
  }
}

.box-feedback {
  @apply my-5;
  flex:1;
  &.over-box {
    padding-right: 10px;
  }
}
</style>
